module.exports = __webpack_public_path__ + "b21052cc5a66caad0841e07e5abf941b.gif";